import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Session } from '@models/Sessions/Session';
import { AssetsPipe } from '@pipes/assets.pipe';
import { BusService } from '@services/bus.service';
import { EventsService } from '@services/events.service';

@Component({
  selector: 'app-session-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss'],
})
export class SessionDetailComponent implements OnInit, OnDestroy {
  session: Session;

  constructor(
    private bus: BusService,
    private events: EventsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private assetsPipe: AssetsPipe,
  ) {}

  get thumbnailImage() {
    if (this.session) {
      return this.assetsPipe.transform(
        this.session.config.thumbnail_id ||
          'image/default_session_thumbnail.png',
      );
    }

    return this.assetsPipe.transform('image/default_session_thumbnail.png');
  }

  sessionSuccess(session: Session) {
    this.session = session;
    this.session.config.descriptionRich =
      this.session.config.descriptionRich || this.session.config.description;

    // $('body').animate({scrollTop: $('.sub-navigation').offset().top}, 'slow');
  }

  sessionFailure() {
    this.router.navigate(['not-found']);
  }

  private subscribe() {
    this.bus.subscribe(
      this.events.received.data.session.single.success,
      this.sessionSuccess.bind(this),
    );
    this.bus.subscribe(
      this.events.received.data.session.single.failure,
      this.sessionFailure.bind(this),
    );
  }

  private unsubscribe() {
    this.bus.unsubscribe(
      this.events.received.data.session.single.success,
      this.sessionSuccess.bind(this),
    );
    this.bus.unsubscribe(
      this.events.received.data.session.single.failure,
      this.sessionFailure.bind(this),
    );
  }

  ngOnInit() {
    this.subscribe();

    this.activatedRoute.params.subscribe(params => {
      this.bus.publish(this.events.requested.data.session.single, params.id);
    });
  }

  ngOnDestroy() {
    this.unsubscribe();
  }
}
